import { Component , TemplateRef, ViewChild, PLATFORM_ID ,Inject, OnInit} from '@angular/core';
import { CommonModule,isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { MatDialogModule,MAT_DIALOG_DATA,MatDialogRef } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';

import { MatDialog } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-member-remove',
  standalone: true,
  imports: [MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    FormsModule],
  templateUrl: './member-remove.component.html',
  styleUrl: './member-remove.component.css'
})
export class MemberRemoveComponent {

  constructor(
    public dialogRef: MatDialogRef<MemberRemoveComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clipboard: Clipboard
  ) {
  }
    confirmRemove() {
    this.dialogRef.close(true); // Cierra el diálogo y confirma la acción
  }

}
